import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { usePopOver } from '@xingternal/pop-over';
import { IconNewChat } from '@xingternal/icons';

import { TopBar } from '@xingternal/top-bar';
import { Menu } from '@xingternal/menu';
import { BodyCopy } from '@xingternal/typography';
import SelectList, { SelectListOption } from '@xingternal/malt-select-list';
import * as Types from '@xingternal/pages-graphql-types';

import { NewsCommbox } from '@xingternal/pages-news';
import { PageContext, EditContext } from '@xingternal/pages-common';

import { Button } from '@xingternal/button';

import styles from './TopBarWrapper.css';

type TopBarWrapperProps = {
  isMainPage?: boolean;
};

const CreateButton = () => {
  const popOver = usePopOver();

  const moreButtonClick = () => {
    popOver.handleShow();
  };

  const { pageContext } = useContext(PageContext);
  if (!pageContext?.pageId) {
    return null;
  }

  const feedQueryVars = {
    id: pageContext.pageId,
    limit: 3,
    filter: Types.PostingPublicationState.Published,
  };
  const canEditLinkPreview = pageContext?.focusType === 'PUBLISHER';

  return (
    <>
      <NewsCommbox
        canEditLinkPreview={canEditLinkPreview}
        feedQueryVars={feedQueryVars}
        setLazyLoadingIsAllowed={() => {}}
      >
        {(onClick: () => void) => (
          <>
            <Button
              className={styles.moreButton}
              onClick={() => moreButtonClick()}
              innerRef={popOver.triggerRef}
              size={'small'}
              aria-label="New Chat"
            >
              <IconNewChat width={20} height={20} />
            </Button>
            <Menu
              onOutsideClick={popOver.handleHide}
              triggerRef={popOver.triggerRef}
              show={popOver.show}
            >
              <>
                <BodyCopy
                  noMargin
                  size={'small'}
                  className={styles.moreMenuTitle}
                >
                  <FormattedMessage
                    id={'EP_ARMSTRONG_CREATE'}
                    defaultMessage={'EP_ARMSTRONG_CREATE'}
                  />
                </BodyCopy>
                <SelectList className={styles.listWrapper}>
                  <SelectListOption
                    className={styles.listItem}
                    onClick={() => {
                      popOver.handleHide();
                      // return body to normal overflow
                      document.body.style.overflow = 'visible';
                      onClick();
                    }}
                  >
                    <BodyCopy noMargin size={'small'} className={styles.link}>
                      <FormattedMessage id="EP_ARMSTRONG_CREATE_POST" />
                    </BodyCopy>
                  </SelectListOption>
                </SelectList>
              </>
            </Menu>
          </>
        )}
      </NewsCommbox>
    </>
  );
};

const TopBarWrapper = ({ isMainPage }: TopBarWrapperProps) => {
  const { pageContext } = useContext(PageContext);
  const editContext = useContext(EditContext);

  return (
    <TopBar
      title={
        (isMainPage ? pageContext?.pageTitle : pageContext?.moduleTitle) ||
        'XING'
      }
      subTitle={(!isMainPage && pageContext?.pageTitle) || undefined}
      type={'subheader'}
      action={
        isMainPage &&
        pageContext?.hasNewsModule &&
        editContext?.isEditor && <CreateButton />
      }
      skipAdditionalButtons
    />
  );
};

export default TopBarWrapper;
